import { createApp } from 'vue'
import ToneTrainerTool from '../components/ToneTrainerTool.vue'

export function mountToneTrainer() {
  const el = document.getElementById('tone-trainer-app')
  if (!el) return

  createApp(ToneTrainerTool, {
    itemsUrl: el.dataset.itemsUrl,
    contourUrl: el.dataset.contourUrl,
    referenceUrl: el.dataset.referenceUrl,
    demoUrl: el.dataset.demoUrl,
    backUrl: el.dataset.backUrl,
    registrationUrl: el.dataset.registrationUrl,
    tonePracticeSignupUrl: el.dataset.tonePracticeSignupUrl,
  }).mount(el)
}
